import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import Header from "../../components/common/Header/Header";
import { AppDispatch } from "../../redux/store";
import RootState from "../../redux/states/root.state";
import { fetchUpgradeRequests } from "../../redux/actions/upgradeRequests.actions";
import UpdateHistoryContainer from "./components/UpdatesContainer";
import { ChipIcon } from "../../components/common/Icons/Icons";

const UpdateHistoryPage: React.FC = () => {
  // Data
  const dispatch: AppDispatch = useDispatch();
  const searchParams = useSearchParams()[0];
  const {meta} = useSelector((state: RootState) => state.upgradeRequests);

  useEffect(() => {
    dispatch(fetchUpgradeRequests(searchParams.toString()))
  }, [dispatch, searchParams]);

  return (
    <div className="page lp-page">
      <Header
        header="Upgrade Requests"
        headerExtra={meta?.total !== undefined &&
          <ul className="lp-stats" aria-label="Summary">
            <li className="lp-stat"><ChipIcon/><b>{(meta?.total ?? 0).toLocaleString()}</b> Requests</li>
          </ul>
        }
      />
      <main className="lp-main">
        <UpdateHistoryContainer/>
      </main>
    </div>
  );
};

export default UpdateHistoryPage;
